/** Return a suburb label without exposing street details from older listings. */
export const getPublicListingSuburb = address => {
  const parts = String(address || '')
    .split(',')
    .map(part => part.trim())
    .filter(Boolean);
  while (parts.length) {
    const part = parts.pop();
    if (/^(Australia|AU)$/i.test(part)) continue;
    const suburb = part
      .replace(/\s*\b(NSW|VIC|QLD|SA|WA|TAS|ACT|NT|New South Wales|Victoria|Queensland|South Australia|Western Australia|Tasmania|Australian Capital Territory|Northern Territory)\b(?:\s+\d{4})?\s*$/i, '')
      .replace(/\s+\d{4}\s*$/, '')
      .trim();
    if (!suburb) continue;
    // Fail closed if all we have is a street, unit or unrecognised address.
    if (/\d/.test(suburb) || /\b(street|st|road|rd|avenue|ave|drive|dr|lane|ln|court|ct|crescent|cres|parade|pde|highway|hwy|place|pl|terrace|tce)\.?$/i.test(suburb) || /^(unit|suite|level)\b/i.test(suburb)) return '';
    return suburb;
  }
  return '';
};
